/* RESPONSIBLE TEAM: team-inbox-management */
import EmbercomBaseSerializer from './base/embercom-base-serializer';

export default class CopilotSettingsSerializer extends EmbercomBaseSerializer {}
